import { VStack, Text } from "@chakra-ui/react";
import { Colors } from "mainstack-design-system";
import "../styles/Loader.css";

export default function Loader({
  bgColor,
  className,
  color = "none",
  textColor = Colors.black300,
}: {
  bgColor?: string;
  className?: string;
  color?: string;
  textColor?: string;
}) {
  return (
    <VStack
      w="100%"
      backgroundColor={bgColor || "transparent"}
      justifyContent="center"
      className={`ms-spinner ${className || ""}`}
    >
      <svg fill={color} stroke={color} viewBox="25 25 50 50">
        <circle cx="50" cy="50" r="20" fill={"none"} className="path"></circle>
      </svg>
      <Text color={textColor} textAlign="center" mt={3}>
        Loading
      </Text>
    </VStack>
  );
}
